export const REFRESH_LOCK_KEY = 'refresh_lock';
export const HAS_SESSION_KEY = 'has_session';

export const MINIMUM_SIGNUP_AGE = 14;
export const GROUP_REQUIRED_AGE_MAX = 16;
export const MINIMUM_SIGNUP_AGE_MESSAGE = `You must be at least ${MINIMUM_SIGNUP_AGE} years old`;

export const TRADE_INTENT_PARAMS = {
	MARKET_ID: 'marketId',
	POSITION: 'position',
	PICK_MATCH_ID: 'pickMatchId',
} as const;
